
export enum MessageDirection {
  C2D = 'C2D',
  D2C = 'D2C',
}

export enum Importance {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export const ImportanceDisplayValues = {
  [Importance.LOW]: 'Low',
  [Importance.MEDIUM]: 'Medium',
  [Importance.HIGH]: 'High',
  [Importance.CRITICAL]: 'Critical',
};

export enum MessageType {
  ACK_NOTIFICATION_TASK = 'ACK_NOTIFICATION_TASK',
  MESSAGE = 'MESSAGE',
  ALERT = 'ALERT',
  SYSTEM_TEST = 'SYSTEM_TEST',
}

export type ReplyToTask = {
  id: string;
  rawId?: string;
  message?: string;
};

export const notificationTaskFragment = graphql(`
  fragment NotificationTaskFragment on NotificationTask @_unmask {
    id
    messageId
    message
    type
    machine {
      __typename
      machineId
      ... on CurrentMachine {
        id
      }
      ... on PreOwnedMachine {
        renouncedDate
      }
    }
    dispatchedTimestamp
    importance
    direction
    delivered
    seen
    done
    replyTo {
      id
      message
      machineId
    }
  }
`);

export type NotificationTask = FragmentOf<typeof notificationTaskFragment>;

// FIXME: the machine object must now be preOwned or Current machine
export const getNotificationTaskByIdQueryDefinition = graphql(`
  query GetNotificationTaskById($messageId: ID!) {
    notificationTasks(where: { id: { eq: $messageId } }) {
      nodes {
        ...NotificationTaskFragment
      }
    }
  }
`, [notificationTaskFragment]);

export const numberOfDaysLatestData = 30;

